(() => {
  const start = () => {
    let gridFrame = 0;
    const normalizeProductGrids = () => {
      cancelAnimationFrame(gridFrame);
      gridFrame = requestAnimationFrame(() => {
        document.querySelectorAll('.template-index .section-product-with-banner .halo-row.slick-initialized').forEach((row) => {
          if (!window.jQuery) return;
          const carousel = window.jQuery(row);
          if (typeof carousel.slick === 'function') carousel.slick('unslick');
        });
      });
    };
    normalizeProductGrids();
    const productSections = document.querySelectorAll('.template-index .section-product-with-banner');
    if (productSections.length && 'MutationObserver' in window) {
      const gridObserver = new MutationObserver(normalizeProductGrids);
      productSections.forEach((section) => gridObserver.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }));
      window.addEventListener('resize', normalizeProductGrids, { passive: true });
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = document.querySelectorAll('.sn-hero, .sn-app[data-sonilux-reveal], .template-index .section-product-1, .template-index .section-product-with-banner, .template-index .section-product-1 .halo-item');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) return;
    document.body.classList.add('sn-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('sn-in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px 50px 0px' });
    targets.forEach((target) => observer.observe(target));
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const grid = document.querySelector('.sn-apps__grid');
      if (grid) {
        let frame = 0;
        grid.addEventListener('pointermove', (event) => {
          const card = event.target.closest('.sn-app');
          if (!card) return;
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const rect = card.getBoundingClientRect();
            card.style.setProperty('--sn-spot-x', `${event.clientX - rect.left}px`);
            card.style.setProperty('--sn-spot-y', `${event.clientY - rect.top}px`);
          });
        }, { passive: true });
      }
      document.querySelectorAll('.template-index .section-product-with-banner').forEach((section) => {
        let frame = 0;
        section.addEventListener('pointermove', (event) => {
          const card = event.target.closest('.product-card');
          if (!card) return;
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const rect = card.getBoundingClientRect();
            card.style.setProperty('--sn-card-x', `${event.clientX - rect.left}px`);
            card.style.setProperty('--sn-card-y', `${event.clientY - rect.top}px`);
          });
        }, { passive: true });
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
